module.exports = __webpack_public_path__ + "static/media/roeseliana_roeselii_004_APA.1b8c738f.png";